import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './RecipeDetail.css';

// Page de details d'une recette
// Affiche toutes les informations d'une recette
function RecipeDetail() {
    // Recupere l'ID de la recette depuis l'URL
    const { id } = useParams();
    const navigate = useNavigate();

    // States pour gerer les donnees
    const [recipe, setRecipe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fonction pour extraire les ingredients et mesures
    // L'API retourne strIngredient1, strIngredient2... jusqu'a 20
    const getIngredients = (meal) => {
        const ingredients = [];

        for (let i = 1; i <= 20; i++) {
            const ingredient = meal[`strIngredient${i}`];
            const measure = meal[`strMeasure${i}`];

            // On ajoute seulement si l'ingredient existe
            if (ingredient && ingredient.trim()) {
                ingredients.push(`${measure || ''} ${ingredient}`.trim());
            }
        }

        return ingredients;
    };

    // useEffect pour charger les details de la recette
    useEffect(() => {
        const fetchRecipeDetail = async () => {
            try {
                setLoading(true);
                setError(null);

                // Appel a l'API avec l'ID de la recette
                const response = await fetch(
                    `https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`
                );
                const data = await response.json();

                // Verifie si la recette existe
                if (data.meals && data.meals.length > 0) {
                    setRecipe(data.meals[0]);
                } else {
                    setError('Recette non trouvee');
                }
            } catch (err) {
                console.error('Erreur:', err);
                setError('Une erreur est survenue');
            } finally {
                setLoading(false);
            }
        };

        fetchRecipeDetail();
    }, [id]);

    // Affichage pendant le chargement
    if (loading) {
        return (
            <div className="recipe-detail">
                <div className="loader">Chargement...</div>
            </div>
        );
    }

    // Affichage si recette non trouvee
    if (error || !recipe) {
        return (
            <div className="recipe-detail">
                <div className="error-message">{error || 'Recette non trouvee'}</div>
                <button className="back-button" onClick={() => navigate(-1)}>
                    Retour
                </button>
            </div>
        );
    }

    // Recupere la liste des ingredients
    const ingredients = getIngredients(recipe);

    return (
        <div className="recipe-detail">
            {/* Bouton retour */}
            <button className="back-button" onClick={() => navigate(-1)}>
                Retour aux resultats
            </button>

            {/* En-tete avec image et infos principales */}
            <div className="recipe-header">
                <img
                    src={recipe.strMealThumb}
                    alt={recipe.strMeal}
                    className="recipe-detail-image"
                />
                <div className="recipe-header-info">
                    <h1 className="recipe-detail-title">{recipe.strMeal}</h1>
                    <p className="recipe-detail-category">
                        Categorie: {recipe.strCategory}
                    </p>
                    <p className="recipe-detail-area">
                        Origine: {recipe.strArea}
                    </p>
                </div>
            </div>

            {/* Section ingredients */}
            <div className="recipe-section">
                <h2>Ingredients</h2>
                <ul className="ingredients-list">
                    {ingredients.map((ingredient, index) => (
                        <li key={index}>{ingredient}</li>
                    ))}
                </ul>
            </div>

            {/* Section instructions */}
            <div className="recipe-section">
                <h2>Instructions</h2>
                <p className="instructions-text">{recipe.strInstructions}</p>
            </div>
        </div>
    );
}

export default RecipeDetail;
